import _extends from "@babel/runtime/helpers/extends";
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLocale } from '@jobmatchme/ui/es/utils/functions';
i18n.use(initReactI18next) // passes i18n down to react-i18next
.init({
  lng: getLocale(),
  resources: {
    de: {
      'react-auth-ui': require('@jobmatchme/react-auth-ui/es/locales/de/react-auth-ui.json'),
      'profile-properties': {
        common: require('@jobmatchme/profile-components/es/locales/de/commonProfile.json'),
        care: require('@jobmatchme/profile-components/es/locales/de/careProfile.json'),
        truck: require('@jobmatchme/profile-components/es/locales/de/truckProfile.json'),
        'service-gastro': require('@jobmatchme/profile-components/es/locales/de/serviceGastroProfile.json'),
        'logistics-scheduler': require('@jobmatchme/profile-components/es/locales/de/logisticsSchedulerProfile.json')
      },
      ui: require('@jobmatchme/ui/es/locales/de/ui.json'),
      'bc-dashboard': _extends({}, require('@jobmatchme/bc-dashboard/es/locales/de/bc-dashboard.json'), {
        common: require('@jobmatchme/bc-dashboard/es/locales/de/commonFunnelSteps.json'),
        care: require('@jobmatchme/bc-dashboard/es/locales/de/careFunnelSteps.json'),
        truck: require('@jobmatchme/bc-dashboard/es/locales/de/truckFunnelSteps.json'),
        'logistics-scheduler': require('@jobmatchme/bc-dashboard/es/locales/de/logisticsSchedulerFunnelSteps.json'),
        'service-gastro': require('@jobmatchme/bc-dashboard/es/locales/de/serviceGastroFunnelSteps.json')
      }),
      'pc-matching': _extends({}, require('@jobmatchme/pc-matching/es/locales/de/common.json')),
      'profile-components': _extends({}, require('@jobmatchme/profile-components/es/locales/de/profile-components.json')),
      'pc-funnel': _extends({
        funnel: require('@jobmatchme/pc-funnel/es/locales/de/pc-funnel.json'),
        common: require('@jobmatchme/pc-funnel/es/locales/de/commonFunnelSteps.json'),
        care: require('@jobmatchme/pc-funnel/es/locales/de/careFunnelSteps.json'),
        truck: require('@jobmatchme/pc-funnel/es/locales/de/truckFunnelSteps.json'),
        'service-gastro': require('@jobmatchme/pc-funnel/es/locales/de/serviceGastroFunnelSteps.json'),
        'logistics-scheduler': require('@jobmatchme/pc-funnel/es/locales/de/logisticsSchedulerFunnelSteps.json'),
        registration: require('@jobmatchme/pc-funnel/es/locales/de/registrationSteps.json')
      }, require('@jobmatchme/pc-funnel/es/locales/de/generics.json'))
    },
    pl: {
      'profile-properties': {
        common: require('@jobmatchme/profile-components/es/locales/pl/commonProfile.json'),
        care: require('@jobmatchme/profile-components/es/locales/pl/careProfile.json'),
        truck: require('@jobmatchme/profile-components/es/locales/pl/truckProfile.json'),
        'service-gastro': require('@jobmatchme/profile-components/es/locales/pl/serviceGastroProfile.json'),
        'logistics-scheduler': require('@jobmatchme/profile-components/es/locales/pl/logisticsSchedulerProfile.json')
      },
      ui: require('@jobmatchme/ui/es/locales/pl/ui.json'),
      'pc-matching': _extends({}, require('@jobmatchme/pc-matching/es/locales/pl/common.json')),
      'profile-components': _extends({}, require('@jobmatchme/profile-components/es/locales/pl/profile-components.json')),
      'pc-funnel': _extends({
        funnel: require('@jobmatchme/pc-funnel/es/locales/pl/pc-funnel.json'),
        common: require('@jobmatchme/pc-funnel/es/locales/pl/commonFunnelSteps.json'),
        care: require('@jobmatchme/pc-funnel/es/locales/pl/careFunnelSteps.json'),
        truck: require('@jobmatchme/pc-funnel/es/locales/pl/truckFunnelSteps.json'),
        'service-gastro': require('@jobmatchme/pc-funnel/es/locales/pl/serviceGastroFunnelSteps.json'),
        'logistics-scheduler': require('@jobmatchme/pc-funnel/es/locales/pl/logisticsSchedulerFunnelSteps.json'),
        registration: require('@jobmatchme/pc-funnel/es/locales/pl/registrationSteps.json')
      }, require('@jobmatchme/pc-funnel/es/locales/pl/generics.json')),
      'bc-dashboard': _extends({}, require('@jobmatchme/bc-dashboard/es/locales/pl/bc-dashboard.json'), {
        common: require('@jobmatchme/bc-dashboard/es/locales/pl/commonFunnelSteps.json'),
        care: require('@jobmatchme/bc-dashboard/es/locales/pl/careFunnelSteps.json'),
        truck: require('@jobmatchme/bc-dashboard/es/locales/pl/truckFunnelSteps.json'),
        'logistics-scheduler': require('@jobmatchme/bc-dashboard/es/locales/pl/logisticsSchedulerFunnelSteps.json'),
        'service-gastro': require('@jobmatchme/bc-dashboard/es/locales/pl/serviceGastroFunnelSteps.json')
      })
    }
  },
  ns: ['ui', 'bc-dashboard', 'profile-components', 'pc-matching', 'pc-funnel', 'profile-properties'],
  //lng: ['de', 'pl'],
  fallbackLng: 'de',
  react: {
    useSuspense: false
  },
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});
export default i18n;